import React from "react";
import {
    Show,
    TextField,
    ReferenceField,
    SimpleForm,
    DateField,
    NumberField,
    ArrayField,
    Datagrid,
    FunctionField,
} from "react-admin";

import { useForm } from "react-final-form";

export const ExternalIsolatesShow = (props) => {
    return (
        <Show {...props}>
            <SimpleForm>
                <TextField label="Code" source="code" />

                <TextField label="Code external" source="code_external" />

                <TextField label="Type external" source="type_external" />

                <TextField label="Specie" source="specie" />

                <TextField label="Study source" source="study_source" />

                <ReferenceField
                    label="Provider"
                    source="id_provider"
                    reference="providers"
                    link="show"
                >
                    <TextField source="name" />
                </ReferenceField>

                <DateField label="Study date" source="study_date" locales="es-UY" />

                <TextField label="Notes" source="notes" />

                <TextField label="Specie" source="specie" />
                <TextField label="Study source" source="study_source" />

                <DateField label="Study date" source="study_date" />

                <TextField label="Notes" source="notes" multiline minRows={6} />

                {/* Storage */}
                <div className="">STORAGE</div>

                <ArrayField source="isolates_storages" label="Isolates positions">
                    <Datagrid>
                        <ReferenceField
                            source="id_storage"
                            label="Storage"
                            reference="storages"
                            link={false}
                        >
                            <TextField source="storage" />
                        </ReferenceField>
                        <TextField source="cryobox_name" label="Cryobox name" />

                        <NumberField source="cryobox_size" label="Size" />
                        <TextField source="cryobox_position" label="Position" />

                        <TextField source="notes" label="Notes" multiline minRows={6} />
                    </Datagrid>
                </ArrayField>
                <ArrayField source="antibiotics_interpretations" label="Antibibotics interpretations">
                    <Datagrid>
                        <ReferenceField
                            source="id_antibiotic"
                            label="Antibiotic"
                            reference="antibiotics"
                            link={true}
                        >
                            <TextField source="name" />
                        </ReferenceField>
                        <FunctionField
                            label="Interpretation"
                            render={mapInterpretation}
                        />;
                        <FunctionField
                            label="CIM Value"
                            render={record => mapOperator(record)}
                        />;
                        <TextField source="notes" label="Notes" multiline minRows={6} />
                    </Datagrid>
                </ArrayField>
                <ArrayField source="antibiotics_discrete" label="Discrete antibibotics interpretations">
                    <Datagrid>
                        <ReferenceField
                            source="id_antibiotic"
                            label="Antibiotic"
                            reference="antibiotics"
                            link={true}
                        >
                            <TextField source="name" />
                        </ReferenceField>
                        <FunctionField
                            label="Interpretation"
                            render={mapInterpretation}
                        />;
                        <TextField source="notes" label="Notes" multiline minRows={6} />
                    </Datagrid>
                </ArrayField>
            </SimpleForm>
        </Show>
    );
};

const mapInterpretation = record => {
    let name;
    switch (record.mic_interpretation) {
        case 'I':
            name = "Intermediate";
            break;
        case 'S':
            name = "Susceptible";
            break;
        case 'R':
            name = "Resistant";
            break;
        case 'P':
            name = "Positive";
            break;
        case 'N':
            name = "Negative";
            break;
        default:
            name = "UNDEFINED";
            break;
    }
    return name;
}

const mapOperator = record => {
    let operator;
    switch (record.mic_operator) {
        case 'le':
            operator = "<=";
            break;
        case 'lt':
            operator = "<";
            break;
        case 'ge':
            operator = ">=";
            break;
        case 'gt':
            operator = ">";
            break;
        case 'eq':
            operator = "=";
            break;
        case 'ne':
            operator = "!=";
            break;
        default:
            operator = "";
            break;
    }
    return operator && record.mic_value ? (operator + " " + record.mic_value) : 'NA';
} 
